//funzione per invertire punto di partenza e di arrivo
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { useTranslation } from 'react-i18next';
const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(0),
    minWidth: 100,
  },
  selectEmpty: {
    marginTop: theme.spacing(0),
  },
}));

export default function PartenzaArrivo(props) {
  const classes = useStyles();
  const [status, setStatus] = React.useState(props.partenza);
  const { i18n } = useTranslation();
  const handleChange = (event) => {
      props.callback(event.target.value)
    setStatus(event.target.value);
  };

  return (
    
        <FormControl className={classes.formControl}>
        <Select
        
          value={status}
          onChange={handleChange}
          displayEmpty
          className={classes.selectEmpty}
          inputProps={{ 'aria-label': 'Without label' }}
          
        >
          <MenuItem value={false}>
            <em className={"parti"}>{i18n.t('Partenza')}</em>
          </MenuItem>
          <MenuItem value={true}>{i18n.t('Arrivo')}</MenuItem>
        </Select>
      </FormControl>
   )}